import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "h-full p-8 flex text-center flex-col" }
const _hoisted_2 = { class: "font-bold text-4xl" }
const _hoisted_3 = {
  key: 0,
  class: "z-20 flex justify-center items-center ml-3 w-full absolute"
}
const _hoisted_4 = {
  key: 1,
  class: "grid grid-cols-1 grid-rows-3"
}
const _hoisted_5 = { class: "invisible sm:visible font-normal text-2xl mb-4" }
const _hoisted_6 = { class: "visble sm:invisible w-full flex justify-center items-center" }
const _hoisted_7 = { class: "hidden" }
const _hoisted_8 = {
  ref: "dropzonePreviewContainer",
  class: "dz-preview dz-file-preview w-40 mi-h-28 flex flex-col justify-center items-center hover:bg-blue-default10 p-3 rounded relative"
}
const _hoisted_9 = {
  "data-dz-remove": "",
  class: "cursor-pointer absolute flex justify-center items-center top-2 right-2 bg-red-default rounded-full w-6 h-6 shadow hover:shadow-xl"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "dz-filename text-blue font-body text-sm mt-3 w-full" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "inline-block w-full text-center break-words",
    "data-dz-name": ""
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CircleLoader = _resolveComponent("CircleLoader")!
  const _component_BaseIcon = _resolveComponent("BaseIcon")!
  const _component_base_button = _resolveComponent("base-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.t('myWorks.upload.stepOne.title')), 1),
      _createElementVNode("div", {
        ref: "dropzoneContainer",
        class: "h-full m-8 bg-text-white border-2 border-black border-dashed flex justify-center items-center",
        onClick: _cache[0] || (_cache[0] = (event) => _ctx.openFileExplorer(event))
      }, [
        (_ctx.isLoading === true)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_CircleLoader)
            ]))
          : _createCommentVNode("", true),
        (_ctx.addedFiles === 0 && _ctx.isLoading === false)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.t(`myWorks.upload.stepOne.sleep`)), 1),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_BaseIcon, {
                  icon: "upload",
                  class: "stroke-current p-4 cursor-pointer"
                })
              ]),
              _createVNode(_component_base_button, {
                text: _ctx.t('myWorks.upload.stepOne.uploadFromComputer'),
                "custom-style": "ghost-purple",
                "icon-shown": true,
                "custom-icon": "upload",
                class: "invisible sm:visible px-2 mx-3 ml-3 justify-center"
              }, null, 8, ["text"])
            ]))
          : _createCommentVNode("", true)
      ], 512)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("a", _hoisted_9, [
          _createVNode(_component_BaseIcon, {
            icon: "close",
            class: "stroke-current p-1 cursor-pointer"
          })
        ]),
        _createVNode(_component_BaseIcon, {
          icon: "file",
          class: "stroke-current p-1"
        }),
        _hoisted_10
      ], 512)
    ])
  ], 64))
}